import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AnalyticsService } from '../_services/analytics.service';
import { SettingsProvider } from '../_services/settingsProvider.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(public settings: SettingsProvider, private analytics: AnalyticsService, public auth: AuthenticationService) {}

  ngOnInit(): void {
    this.analytics.setTitleAndLogPageView(this.settings.brand.brandName + ' - Home');
  }
}
